import { MatDialogRef } from '@angular/material/dialog';

export interface DialogState {
  ref: MatDialogRef<any> | null;
}

export const initialState: DialogState = {
  ref: null,
};
